import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './context/authContext';
import LoadingComponent from "assets/theme/functions/loadingAnimation";

const ProtectedRoute = ({ children }) => {
  const [allowed, setAllowed] = useState(null);
  const { isAuthenticated } = useAuth();

  useEffect(() => {

    const checkAuth = async () => {
      const auth = await isAuthenticated();
      console.log("ProtectedRouter: ", auth)
      setAllowed(auth);
    };

    checkAuth();

  }, []);

  if (allowed === null) {
    return <LoadingComponent />
  }

  if (!allowed) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;